import styled, { css } from 'styled-components'
import InlineLoader from 'components/InlineLoader'
import CustomScroll from 'react-custom-scroll'
import 'styles/custom_scroll.css'
import { Row, Col } from 'react-bootstrap'
import { useKendra } from '../../hooks'

const Container = styled.div`
  background: var(--white);
  border-radius: 5px;
  width: 100%;
  display: flex;
  flex-flow: column;
  margin-bottom: 30px;
`

const Title = styled.div`
  border-bottom: 1px solid #eeeeee;
  font-size: 16px;
  padding: 15px 20px;
  border-radius: 4px 4px 0 0;

  .fa {
    color: ${(props) => (props.blue ? 'var(--white)' : 'var(--main-color)')};
    font-size: 18px;
  }

  ${(props) =>
    props.blue &&
    css`
      background: var(--main-color);
      color: var(--white);
    `}
`
const Content = styled.div`
  padding: ${(props) => props.padding || '20px'};
  height: ${(props) => (props.height ? props.height : 'auto')};
  ${props => props.isKendraEnabled && css`overflow: auto;`}
`
const ContentWrapper = styled.div`
  height: 100%;
  width: 100%;
  .no-content {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
    width: 100%;
    color: #989898;
    font-size: 16px;
  }
`

const Footer = styled.div`
  border-top: 1px solid #eeeeee;
  padding: 15px;
`

const Panel = ({
  title,
  children,
  footer,
  buttons,
  className,
  blue,
  height,
  padding
}) => {
  const { isKendraEnabled } = useKendra()
  // Filter out null array values
  if (children && Array.isArray(children)) {
    children = children.filter((e) => e)
  }

  return (
    <Container className={className}>
      <Title className="clearfix" blue={blue}>
        <Row>
          <Col xs={8}>{title || 'Loading...'}</Col>
          <Col xs={4} className="text-right">
            {buttons}
          </Col>
        </Row>
      </Title>

      <Content
        height={height}
        padding={padding}
        isKendraEnabled={isKendraEnabled}
      >
        {!children || (children.length === 0 && <InlineLoader />)}
        {children && (
          <>
            {height && (
              <CustomScroll heightRelativeToParent="100%" allowOuterScroll>
                <ContentWrapper>{children}</ContentWrapper>
              </CustomScroll>
            )}

            {!height && <ContentWrapper>{children}</ContentWrapper>}
          </>
        )}
      </Content>
      {footer && <Footer>{footer}</Footer>}
    </Container>
  )
}

export default Panel
